import ReactApexChart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';
import './HeatMap.css';

export default function HeatMap(props: any) {
  if (!props.data || props.data[0].data.length === 0) {
    return <></>;
  }
  const turbineHeight = props.data[0].data.filter(
    (elem: any) => elem.z === true,
  );
  const options: ApexOptions = {
    chart: {
      type: 'heatmap',
      toolbar: { show: false },
      events: {
        mounted: function (chartContext, config) {
          let oldBottomLine: HTMLElement = document.getElementById(
            'bottom-line',
          ) as HTMLElement;
          if (oldBottomLine) {
            oldBottomLine.remove();
          }
          let annotationLabel: any = document.getElementsByClassName(
            'apexcharts-xaxis-heatmap-annotation',
          );
          const svg = annotationLabel[0].closest(
            '.apexcharts-xaxis-annotations',
          );
          let lineElements = svg.querySelectorAll('line');
          const chart: any = document.getElementById('heatmap');
          let bottomDiv = document.createElement('div');
          bottomDiv.id = 'bottom-line';
          bottomDiv.className = 'bar-custom-horizontal-annotation';
          bottomDiv.style.height = '605px';
          bottomDiv.style.width = '3px';
          bottomDiv.style.top = '-120px';
          bottomDiv.style.left = '560px';
          let bottomTextSpan = document.createElement('span');
          bottomTextSpan.className = 'horizontal-line-bottom-text';
          bottomTextSpan.innerHTML = '0&nbsp;m';

          bottomDiv.appendChild(bottomTextSpan);
          chart?.appendChild(bottomDiv);
          let div = document.createElement('div');
          div.id = 'dotted-line';
          div.className = 'bar-custom-horizontal-annotation';
          div.style.height = '620px';
          div.style.width = '3px';
          div.style.top = '-120px';
          div.style.left =
            parseInt(lineElements[0].getAttribute('x1')) + 9 + 'px'; //parentElement.top + 'px';
          const turbineHeight = config.config.series[0].data.filter(
            (elem: any) => elem.z === true,
          );
          if (turbineHeight.length > 0) {
            let heightTextSpan = document.createElement('span');
            heightTextSpan.className = 'horizontal-line-text';
            heightTextSpan.innerHTML = turbineHeight[0].x + 'm';
            div.appendChild(heightTextSpan);

            let div2 = document.createElement('div');
            div2.id = 'line';
            div2.className = 'bar-custom-horizontal-annotation';
            div2.style.height = '620px';
            div2.style.width = '3px';
            div2.style.top = '-120px';
            div2.style.left =
              parseInt(lineElements[1].getAttribute('x1')) + 9 + 'px';
            let heightTextSpan2 = document.createElement('span');
            heightTextSpan2.className = 'horizontal-line-text';
            heightTextSpan2.innerHTML = turbineHeight[1].x + 'm';
            div2.appendChild(heightTextSpan2);
            //chart?.appendChild(div);
            //chart?.appendChild(div2);
          }
        },
      },
    },
    annotations: {
      xaxis: [
        {
          x: turbineHeight && turbineHeight[0] ? turbineHeight[0].x : 100,
          borderColor: 'white',
          label: {
            style: {
              cssClass: 'apexcharts-xaxis-heatmap-annotation',
            },
          },
        },
        {
          x: turbineHeight && turbineHeight[1] ? turbineHeight[1].x : 30,
          borderColor: 'white',
          label: {
            style: {
              cssClass: 'apexcharts-xaxis-heatmap-annotation',
            },
          },
        },
      ],
    },

    plotOptions: {
      heatmap: {
        distributed: false,
        shadeIntensity: 0.5,
        radius: 0,
        useFillColorAsStroke: true,
        colorScale: {
          ranges: [
            {
              from: 0,
              to: 0,
              name: 'blank',
              color: '#E8E8E8',
            },

            {
              from: 1,
              to: 1,
              name: 'low',
              color: '#EFE5FC',
            },
            {
              from: 2,
              to: 2,
              name: 'medium',
              color: '#C7AFE7',
            },
            {
              from: 3,
              to: 3,
              name: 'high',
              color: '#A07AD1',
            },
            {
              from: 4,
              to: 4,
              name: 'extreme',
              color: '#7746B9',
            },
            {
              from: 5,
              to: 5,
              name: 'extreme2',
              color: '#4903A1',
            },
          ],
        },
      },
    },
    xaxis: {
      type: 'numeric',
      tickAmount: 10,
      labels: {
        rotate: -90,
        formatter: function (value: any) {
          return value + ' m';
        },
        style: {
          fontWeight: 350,
          fontSize: '12px',
          colors: '#8B8296',
        },
        offsetY: -5,
        offsetX: -1,
      },

      //
    },
    yaxis: {
      labels: {
        show: true,
        style: {
          cssClass: 'apexcharts-heatmap-yaxis-label',
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 1,
    },
    tooltip: {
      enabled: false,
    },
    grid: {
      show: true,
    },
  };

  return (
    <ReactApexChart
      options={options}
      series={props.data}
      type="heatmap"
      width={600}
      height={600}
    />
  );
}
